import {
	Button,
	Menu,
	MenuTrigger,
	MenuPopover,
	MenuList,
	MenuItem,
	LargeTitle,
	makeStyles,
	tokens,
	MenuOpenChangeData
} from '@fluentui/react-components';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppSelector } from '../pgStore';
import { MoreCircle48Filled } from '@fluentui/react-icons';
import { useState } from 'react';
import AddSocialDialog from './AddSocial';
import IconSelection from './IconSelectionDialog';
import { apiPlayerDetails } from '../Redux/Types';

export interface PlayerHeaderProps {
	player: apiPlayerDetails;
	isEditable: boolean;
}

const PlayerHeader = (props: PlayerHeaderProps) => {
	const styles = useStyles();
	const loggedInUsername = useAppSelector(
		(state) => state.userSlice.username
	);
	const [showMenu, setShowMenu] = useState(false);
	const [showAddSocial, setShowAddSocial] = useState(false);
	const [showIconSelect, setShowIconSelect] = useState(false);

	const onMenuOpenChange = (_event: MouseEvent, data: MenuOpenChangeData) => {
		setShowMenu(data.open);
	};

	return (
		<>
			<div className={styles.root}>
				<div>
					<img
						src={
							props.player.profileImageUrl &&
							props.player.profileImageUrl !== ''
								? props.player.profileImageUrl
								: 'https://peergamingstorage.blob.core.windows.net/profile-icons/Squid-100.png'
						}
						title={props.player.username}
						alt='Profile Icon'
					/>
				</div>

				<LargeTitle>{props.player.username}</LargeTitle>

				<div className={styles.actions}>
					{
						// If there is a logged in user and this isn't their profile they can Follow
						loggedInUsername && !props.isEditable && (
							<Button
								type='button'
								className='btn btn-success'
								appearance='primary'
								disabled
								title='Coming Soon'
							>
								<FontAwesomeIcon icon={faPlus} />
								Follow
							</Button>
						)
					}

					{loggedInUsername && props.isEditable && (
						<Menu
							open={showMenu}
							onOpenChange={onMenuOpenChange}
						>
							<MenuTrigger>
								<Button
									appearance='transparent'
									icon={<MoreCircle48Filled />}
								/>
							</MenuTrigger>

							<MenuPopover>
								<MenuList>
									<MenuItem
										onClick={() => {
											setShowAddSocial(true);
										}}
									>
										Add Social Platform
									</MenuItem>
									<MenuItem
										onClick={() => {
											setShowIconSelect(true);
										}}
									>
										Change Profile Icon
									</MenuItem>
									<MenuItem disabled>
										Change Cover Image
									</MenuItem>
								</MenuList>
							</MenuPopover>
						</Menu>
					)}
				</div>
			</div>

			{showAddSocial && (
				<AddSocialDialog
					isOpen={showAddSocial}
					setIsOpen={setShowAddSocial}
					username={props.player.username}
				/>
			)}

			{showIconSelect && (
				<IconSelection
					username={props.player.username}
					isOpen={showIconSelect}
					setIsOpen={setShowIconSelect}
				/>
			)}
		</>
	);
};

export default PlayerHeader;

const useStyles = makeStyles({
	root: {
		display: 'flex',
		justifyContent: 'left',
		alignItems: 'center',
		padding: '10px 15px',
		columnGap: '15px',
		flexWrap: 'wrap',
		backgroundColor: tokens.colorNeutralBackground1,
		borderRadius: '5px'
	},
	actions: {
		marginLeft: 'auto'
	}
});
